import React from 'react';

import styled from '@material-ui/core/styles/styled';
import { useTranslation } from 'react-i18next';

import CertificateSmallIcon from '../../../../assets/icons/CertificateSmallIcon';
import ClockSmallIcon from '../../../../assets/icons/ClockSmallIcon';
import CpdSmallIcon from '../../../../assets/icons/CpdSmallIcon';
import ExpertsSmallIcon from '../../../../assets/icons/ExpertsSmallIcon';
import OnlineSmallIcon from '../../../../assets/icons/OnlineSmallIcon';
import PathwaySmallIcon from '../../../../assets/icons/PathwaySmallIcon';
import { colorsPalette } from '../../../../theme';
import { useStyles } from './styles';

const CourseTags = ({ pathways, hours, experts, CPD }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TagsList>
      <TagItem>
        <CertificateSmallIcon className={classes.icon} color={colorsPalette.violet} />
        {t('page.coursesList.shareableCertificate')}
      </TagItem>
      {pathways && (
        <TagItem>
          <PathwaySmallIcon className={classes.icon} color={colorsPalette.violet} />
          {t('page.coursesList.contentPathways', { count: pathways })}
        </TagItem>
      )}
      {hours && (
        <TagItem>
          <ClockSmallIcon className={classes.icon} color={colorsPalette.violet} />
          {t('page.coursesList.hoursOfLearning', { count: hours })}
        </TagItem>
      )}
      <TagItem>
        <OnlineSmallIcon className={classes.icon} color={colorsPalette.violet} />
        {t('page.coursesList.online')}
      </TagItem>
      {experts && (
        <TagItem>
          <ExpertsSmallIcon className={classes.icon} color={colorsPalette.violet} />
          {t('page.coursesList.expertPresenters', { count: experts })}
        </TagItem>
      )}
      {CPD && (
        <TagItem>
          <CpdSmallIcon className={classes.icon} color={colorsPalette.violet} />
          {t('page.coursesList.CPDCredits', { count: CPD })}
        </TagItem>
      )}
    </TagsList>
  );
};

export default CourseTags;

const TagsList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  margin: '0 -12px',
  paddingLeft: 0,
  listStyleType: 'none',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
const TagItem = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  margin: '0 12px 8px',
  color: colorsPalette.gray,
  [theme.breakpoints.up('md')]: {
    width: 'calc(100% / 3 - 24px)',
  },
}));
